import surinameFlag from '../assets/images/Flag_of_Suriname.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-600 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <div className="flex items-center space-x-2 mb-2">
              <img 
                src={surinameFlag} 
                alt="Suriname" 
                className="h-4 w-6 object-cover rounded shadow-sm"
              />
              <p className="text-sm">
                © {currentYear} Sranslate™. All rights reserved.
              </p>
            </div>
            <p className="text-xs text-primary-200 mt-1">
              Dutch to Sranantongo Translation Service - Beta Version
            </p>
            <p className="text-xs text-primary-200 mt-1">
              Made with ❤️ for Suriname
            </p>
            <p className="text-xs text-primary-200 mt-1">
              Questions? Email: <a href="mailto:info@sranslate.nl" className="underline hover:text-white">info@sranslate.nl</a>
            </p>
          </div>
          
          <div className="flex flex-col items-center md:items-end space-y-1">
            <p className="text-xs text-primary-200">
              Powered by Meta's NLLB-200 Model
            </p>
            <p className="text-xs text-primary-200">
              Deployed on Microsoft Azure
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;